import React from "react"
import propTypes from "prop-types"

import Label from "../Label"
import ErrorMessage from "../ErrorMessage"

const TextArea = ({ field, onChange, isSubmitted }) => {
  return (
    <>
      {field.label && <Label label={field.label} htmlFor={field.name} />}

      {field.placeholder && (
        <div className="form_placeholder">{field.placeholder}</div>
      )}

      <textarea
        id={field.name}
        type={field.type}
        name={field.name}
        value={field.value}
        onChange={e => onChange(field.name, "value", e.target.value)}
        className={[
          "form_element",
          field.class,
          isSubmitted && !!field.message && field.required ? " is-invalid" : ""
        ].join(" ")}
      />

      <ErrorMessage message={field.message} />
    </>
  )
}

TextArea.propTypes = {
  field: propTypes.shape({
    label: propTypes.string,
    placeholder: propTypes.string,
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    value: propTypes.string.isRequired,
    message: propTypes.string,
    required: propTypes.bool.isRequired,
    class: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired
}

export default TextArea
